import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { CHECKOUT_URL, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
const INCLUDED = ['6 comprehensive modules', '5 strategic bonuses', 'Electrical & component testing', 'Refrigerator & freezer diagnostics', 'Washing machine & dryer troubleshooting', 'Dishwasher, oven & range diagnostics', 'Structured fault-finding workflows'];
export function Offer() {
  return <section id="offer" className="scroll-mt-2 border-y-4 border-electric bg-white py-5 sm:py-8" data-id="element-114" data-mp="p0tlyp9ssclq">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-115" data-mp="13y2f9oinvqg3">
        <p className="mx-auto w-fit rounded bg-electric px-3 py-1 font-display text-xs font-extrabold uppercase tracking-widest text-white sm:text-sm" data-id="element-116" data-mp="yxxyryhr6vpv">
          Special launch offer
        </p>

        <div className="mt-2.5 overflow-hidden rounded-xl border-[3px] border-dashed border-electric bg-white" data-id="element-117" data-mp="2ad3fw7imswt0">
          <div className="bg-navy p-3.5 text-center sm:p-5" data-id="element-118" data-mp="pkh5x9amssf5">
            <h2 className="text-xl leading-tight text-white sm:text-3xl" data-id="element-119" data-mp="pjz47x579lzu">🔧 {PRODUCT}</h2>
            <p className="mx-auto mt-1.5 max-w-2xl text-xs font-semibold uppercase leading-tight tracking-wide text-steel sm:text-sm" data-id="element-120" data-mp="uhqw4r5uh841">
              {PRODUCT_TAGLINE}
            </p>
          </div>

          <div className="grid gap-3 p-3.5 sm:p-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-6" data-id="element-121" data-mp="13jgmrurwk30r">
            <MockupImage data-id="element-122" data-mp="6vkav37etvvv" />

            <div data-id="element-123" data-mp="bstycdb8nxh2">
              <p className="font-display text-base font-extrabold uppercase tracking-wide text-navy sm:text-xl" data-id="element-124" data-mp="bsaq5obe4ng8">
                Complete 6-in-1 System
              </p>
              <ul className="mt-1.5 grid gap-1" data-id="element-125" data-mp="fskukwjjb5sz">
                {INCLUDED.map(item => <li key={item} className="flex items-start gap-2" data-id="element-126" data-mp="kn8juxmd448m">
                    <span className="leading-snug" aria-hidden="true" data-id="element-127" data-mp="3k84887lde6ze">
                      ✅
                    </span>
                    <span className="text-sm font-semibold leading-snug text-graphite sm:text-base" data-id="element-128" data-mp="3o84lvq0nae5e">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-3 rounded-lg border-2 border-navy bg-steel px-3 py-2.5 text-center" data-id="element-129" data-mp="155k891z8xpvx">
                <p className="font-display text-sm font-extrabold uppercase leading-tight text-navy sm:text-lg" data-id="element-130" data-mp="106h038nyz3jq">
                  🔥 GET HOME APPLIANCE DIAGNOSTIC PRO™ TODAY —{' '}
                  <span className="whitespace-nowrap text-2xl text-electric sm:text-3xl" data-id="element-131" data-mp="ciz8bd4pg5gr">
                    $27 USD
                  </span>
                </p>
              </div>

              <div className="mt-3 flex flex-col items-center" data-id="element-132" data-mp="liw03nme5kg1">
                <CTAButton href={CHECKOUT_URL} data-id="element-133" data-mp="hfptufza3t9k">⚡ GET INSTANT ACCESS</CTAButton>
                <TrustLine items={['Immediate Digital Access', '🛡️ 7-Day Money-Back Guarantee']} data-id="element-134" data-mp="1wwga77jrqa4f" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}